import React, { useEffect, useRef, useState } from "react";
import CloseIcon from "@mui/icons-material/Close";
import { useDispatch } from "react-redux";
import { setcollectionPopup } from "../../../redux/features/stylesSlice";
import { useSelector } from "react-redux";
import { getConfig, searchAPI } from "../../../apis";
import SidebarCollection from "./SidebarCollection";
import AddIcon from "@mui/icons-material/Add";
import Table from "./Table";
import { toast } from "react-toastify";
import ButtonPrimary from "../../../components/button/ButtonPrimary";
import MenuIcon from "@mui/icons-material/Menu";
import { useLocation, useParams } from "react-router-dom";
import {
  setBookmarkArticle,
  setBookmarkUrls,
  setCitationPopup,
  setSummarizePopup,
  setSummaryInfoData,
} from "../../../redux/features/dataSlice";
import CustomLoader from "../../../components/loader";
import NewBookmark from "../../../pages/NewsCategoryPage/NewBookmark";
import { logEvent } from "../../../functions/amplitude";
import Draggable from "react-draggable";
import { useIsMobile } from "../../../functions/isMobile";
import { axiosInstance } from "../../../functions/axios";

const PopupCollection = () => {
  const isMobile = useIsMobile();

  const dispatch = useDispatch();

  const [sidebarColActive, setsidebarColActive] = useState(false);
  const [bookmarks, setBookmarks] = useState([]);

  const [folderId, setFolderId] = useState(0);
  const { user } = useSelector((state) => state.auth);
  const { pathname } = useLocation();
  const {
    bookmarkData,
    bookmarkUrls,
    summaryInfoData,
    articleSummary,
    bookmarkArticle,
    articleDataCitation,
    citationData,
  } = useSelector((state) => state.data);
  const [collections, setcollections] = useState([]);
  const [loading, setLoading] = useState(true);
  const [newBookmarkPopup, setNewBookmarkPopup] = useState(false);
  const [subNewFolder, setSubNewFolder] = useState(false);
  const [title, setTitle] = useState("");
  const [parentCollectionIds, setParentCollectionIds] = useState([]);
  const [position, setPosition] = useState({
    marginTop: 0,
    marginLeft: 0,
  });

  const divRef = useRef(null);

  const getBookmarks = async (id) => {
    const res = await axiosInstance.post(
      searchAPI.getCollectionsSource,
      {
        callingUserId: user.userId,
        collectionId: id,
      },
      getConfig()
    );
    res.data && setBookmarks(res.data);
    setLoading(false);
  };

  const getParentCollectionIds = (data) => {
    const ids = data
      .filter((collection) => collection.parentCollectionID_lng === 0)
      .map((collection) => collection.collectionID_ids);
    setParentCollectionIds(ids);
  };

  const getData = async () => {
    const res = await axiosInstance.post(
      searchAPI.getCollections,
      {
        callingUserId: user.userId,
        userId: user.userId,
      },
      getConfig()
    );
    setcollections(res.data);
    getParentCollectionIds(res.data);
    if (bookmarks !== null && !folderId) {
      getBookmarks(res.data[0].collectionID_ids);
      if (!folderId) setFolderId(res.data[0].collectionID_ids);
    }
  };

  const saveCollectionFolder = async (name) => {
    let parent = {};
    if (subNewFolder) {
      parent = { parentCollectionId: folderId };
    }
    const requestsData = {
      callingUserId: user.userId,
      userId: user.userId,
      collectionName: name,
      ...parent,
    };
    const { data } = await axiosInstance.post(
      searchAPI.updateCollections,
      requestsData,
      getConfig()
    );
    if (
      data === "Error: Cannot add more than 2 nested levels of collections."
    ) {
      toast.error("Sorry! You can't create more than 2 subfolders.");
      setSubNewFolder(false);
      return;
    }
    toast.success("Collection created successfully.");
    getData();
    setSubNewFolder(false);
  };

  const format_response = () => {
    const commonResponse = {
      callingUserId: user.userId,
      userId: user.userId,
      collectionId: folderId,
      summary: articleSummary,
    };

    if (bookmarkArticle) {
      return {
        ...commonResponse,
        title: summaryInfoData.title,
        sourceName: summaryInfoData.publisher,
        sourceURL: summaryInfoData.url,
        sourcePublishedDateTime: new Date(summaryInfoData.published_date),
      };
    }

    if (pathname.includes("books")) {
      return {
        ...commonResponse,
        title: bookmarkData.title,
        sourceName: "Google Books",
        sourceURL: bookmarkData.infoLink,
        sourcePublishedDateTime: new Date(bookmarkData.publishedDate),
      };
    }

    return {
      ...commonResponse,
      title: summaryInfoData.title ? summaryInfoData.title : bookmarkData.name,
      sourceName: bookmarkData.entityName,
      sourceURL: bookmarkData.url,
      sourcePublishedDateTime: new Date(bookmarkData.publishedDate),
    };
  };

  const handleSavedCitation = async (id) => {
    if (articleDataCitation.citationMeta) {
      try {
        const json_res = {
          ...articleDataCitation,
          collectionSourceId: id,
          userId: user.userId,
          citation: citationData,
        };
        const res = await axiosInstance.post(
          searchAPI.saveCitation,
          json_res,
          getConfig()
        );

        toast.success("Citation saved successfully!");
        dispatch(setCitationPopup(false));
      } catch (e) {
        console.log(e);
      }
    }
  };

  const handleSave = async () => {
    try {
      const json_res = format_response();
      console.log();
      const res = await axiosInstance.post(
        searchAPI.AddUpdateCollectionsSource,
        json_res,
        getConfig()
      );
      handleSavedCitation(res.data);

      const amplitude_bookmark = {
        publication: json_res.sourceName,
        bookmarkurl: json_res.sourceURL,
      };

      logEvent("click_bookmark_save", amplitude_bookmark);
      pathname.includes("books")
        ? dispatch(setBookmarkUrls([...bookmarkUrls, bookmarkData.infoLink]))
        : dispatch(setBookmarkUrls([...bookmarkUrls, bookmarkData.url]));
      toast.success("Saved to collection");
      dispatch(setSummarizePopup(false));
      dispatch(setBookmarkArticle(false));
      dispatch(setcollectionPopup(false));
      dispatch(setSummaryInfoData({}));
    } catch {
      toast.error("Something went wrong, please try later.");
    }
  };

  useEffect(() => {
    if (divRef.current) {
      divRef.current.focus();
    }
  }, []);

  useEffect(() => {
    if (divRef.current) {
      divRef.current.focus();
    }
  }, []);

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      handleSave();
    }
  };

  const handleDrag = (e, ui) => {
    const { x, y } = ui;
    setPosition((prevPosition) => ({
      ...prevPosition,
      marginTop: y,
      marginLeft: x,
    }));
  };

  useEffect(() => {
    getData();
  }, []);

  useEffect(() => {
    getBookmarks(folderId);
  }, [folderId]);

  return (
    <div className="popup-collection-sidebar">
      <div className="bg-dark-popup-collection " />
      {!isMobile ? (
        <Draggable
          defaultPosition={{
            x: position.marginLeft,
            y: position.marginTop,
          }}
          onDrag={handleDrag}
          cancel={isMobile ? ".popup-collection" : null}
        >
          <div
            // ref={divRef}
            // tabIndex="0"
            // onKeyDown={
            //   newBookmarkPopup || subNewFolder ? null : (e) => handleKeyDown(e)
            // }
            className="popup-collection"
          >
            {loading ? (
              <div className="collection-content-loading">
                <CustomLoader />
              </div>
            ) : (
              <>
                <div className="collection-content">
                  <div
                    className="cross"
                    onClick={() => dispatch(setcollectionPopup(false))}
                  >
                    <CloseIcon />
                  </div>
                  <div className="flex-header">
                    <MenuIcon
                      className="mr-1 hd-ds"
                      onClick={() => setsidebarColActive(true)}
                    />
                    <h3>My Collections</h3>
                  </div>
                  <div className="collection-wrapper">
                    <SidebarCollection
                      sidebarColActive={sidebarColActive}
                      setsidebarColActive={setsidebarColActive}
                      data={collections}
                      setFolderId={setFolderId}
                      folderId={folderId}
                      setSubNewFolder={setSubNewFolder}
                      setTitle={setTitle}
                      parentCollectionIds={parentCollectionIds}
                    />
                    <Table bookmarks={bookmarks} />
                  </div>

                  <div className="actions">
                    <ButtonPrimary
                      text="Create New"
                      outline
                      iconLeft={<AddIcon />}
                      onClick={() => setNewBookmarkPopup(true)}
                    />

                    <div className="flex">
                      <ButtonPrimary
                        text="Cancel"
                        outline
                        className="mr-2"
                        onClick={() => dispatch(setcollectionPopup(false))}
                      />

                      <ButtonPrimary text="Save" onClick={handleSave} />
                    </div>
                  </div>
                </div>
              </>
            )}
          </div>
        </Draggable>
      ) : (
        <div
          // ref={divRef}
          // tabIndex="0"
          // onKeyDown={
          //   newBookmarkPopup || subNewFolder ? null : (e) => handleKeyDown(e)
          // }
          className="popup-collection"
        >
          {loading ? (
            <div className="collection-content-loading">
              <CustomLoader />
            </div>
          ) : (
            <>
              <div className="collection-content">
                <div
                  className="cross"
                  onClick={() => dispatch(setcollectionPopup(false))}
                >
                  <CloseIcon />
                </div>
                <div className="flex-header">
                  <MenuIcon
                    className="mr-1 hd-ds"
                    onClick={() => setsidebarColActive(true)}
                  />
                  <h3>My Collections</h3>
                </div>
                <div className="collection-wrapper">
                  <SidebarCollection
                    sidebarColActive={sidebarColActive}
                    setsidebarColActive={setsidebarColActive}
                    data={collections}
                    setFolderId={setFolderId}
                    folderId={folderId}
                    setSubNewFolder={setSubNewFolder}
                    setTitle={setTitle}
                    parentCollectionIds={parentCollectionIds}
                  />
                  <Table bookmarks={bookmarks} />
                </div>

                <div className="actions">
                  <ButtonPrimary
                    text="Create New"
                    outline
                    iconLeft={<AddIcon />}
                    onClick={() => setNewBookmarkPopup(true)}
                  />

                  <div className="flex">
                    <ButtonPrimary
                      text="Cancel"
                      outline
                      className="mr-2"
                      onClick={() => dispatch(setcollectionPopup(false))}
                    />

                    <ButtonPrimary text="Save" onClick={handleSave} />
                  </div>
                </div>
              </div>
            </>
          )}
        </div>
      )}
      {(newBookmarkPopup || subNewFolder) && (
        <NewBookmark
          newBookmarkPopup={newBookmarkPopup}
          setNewBookmarkPopup={setNewBookmarkPopup}
          saveCollectionFolder={saveCollectionFolder}
          setSubNewFolder={setSubNewFolder}
          subNewFolder={subNewFolder}
          title={title}
        />
      )}
      {(newBookmarkPopup || subNewFolder) && (
        <NewBookmark
          newBookmarkPopup={newBookmarkPopup}
          setNewBookmarkPopup={setNewBookmarkPopup}
          saveCollectionFolder={saveCollectionFolder}
          setSubNewFolder={setSubNewFolder}
          subNewFolder={subNewFolder}
          title={title}
        />
      )}
    </div>
  );
};

export default PopupCollection;
